import { render, staticRenderFns } from "./DocDepartment.vue?vue&type=template&id=9c274e64&"
import script from "./DocDepartment.vue?vue&type=script&lang=js&"
export * from "./DocDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocDepartment.vue"
export default component.exports